export function BankMark({ size = 40 }: { size?: number }) {
  return <svg aria-hidden viewBox="0 0 40 40" width={size} height={size} fill="none">
    <circle cx="20" cy="20" r="18.8" fill="var(--brand-green-2)" stroke="var(--brand-gold)" strokeWidth="1.6" />
    <path d="M20 8.5c-5.5 4.3-9.5 6.6-9.5 12.4 0 5.2 4.1 9.3 9.5 10.5 5.4-1.2 9.5-5.3 9.5-10.5 0-5.8-4-8.1-9.5-12.4Z" fill="#f7f0df" />
    <path d="M20 14.5v11M14.5 20h11" stroke="#1c6b4a" strokeWidth="2" strokeLinecap="round" />
  </svg>
}
